import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import { EgHomeModel } from './eg-home-model';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';

declare var $;

@Component({
  selector: 'app-eg-home',
  templateUrl: './eg-home.component.html',
  styleUrls: ['./eg-home.component.css']
})

/** eg-home component*/
export class EgHomeComponent implements OnInit {
  /** eg-home ctor */
  modelItem: EgHomeModel = new EgHomeModel();
  html: string;
  constructor() {
    ApiMethod.getPageConfig().subscribe({
      next: data => {
        this.modelItem = <EgHomeModel>data["nedit"];

        this.html = '<iframe width="100%" height="' + (GlobalConstants.size.height) +'" src="' + this.modelItem.Dashboard + '"></iframe>';
      },
      error: err => {
        ngswal("Warning !", err.message, "warning");
      }
    });
  }

  ngOnInit() {
    $('#page-header-search-dropdown').hide();
   }

  ngAfterViewChecked(): void {
    if ($('#divHtml').html() == '') {
      $('#divHtml').html(this.html);
    }

  }
}
